export default {
  vision_blog: "vision blog".toUpperCase(),
  stay_turned_for__: "Следите за всем, что происходит на Vision.".toUpperCase(),
  all: "все".toUpperCase(),
  articles: "материалы".toUpperCase(),
  show_more: "подробнее".toUpperCase(),
};
